import { render, staticRenderFns } from "./TeacherExamSettings.vue?vue&type=template&id=1d73379f"
import script from "./TeacherExamSettings.vue?vue&type=script&lang=js"
export * from "./TeacherExamSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports